module.exports = __webpack_public_path__ + "static/media/e_image.a4830fb8.JPG";